import { useMutation } from '@apollo/client';
import { ADD_NEW_STEP_TO_NCR } from '../operations/mutations/addNewStepToNcr';

export const useAtomicAddNewStepToNCR = () => {
    const [atomic, { loading }] = useMutation(ADD_NEW_STEP_TO_NCR);

    const handleAtomic = ({ ncrId, operation, path, values, childrenIds }) => {
        return atomic({
            variables: {
                atomics: [
                    {
                        ncrId,
                        operation,
                        path,
                        values,
                        childrenIds,
                    },
                ],
            },
        });
    };

    return [handleAtomic, loading];
};
